import { Component, OnInit, OnDestroy, TemplateRef, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { LoadingService } from 'src/app/shared/loading.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    imports: [CommonModule]
})
export class LoadingComponent implements OnInit, AfterViewInit, OnDestroy {
    loading = false;
    loadingTemplate: TemplateRef<any> | null = null;
    loadingSubscription = new Subscription();

    @ViewChild('spinnerTemplate', { static: false }) spinnerTemplate: TemplateRef<any>;

    constructor(private loadingService: LoadingService, private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.loadingSubscription.add(
            this.loadingService.getLoadingStatus().subscribe((value) => {
                this.loading = value;
                this.cdr.detectChanges();
            })
        );
    }

    ngAfterViewInit(): void {
        this.loadingService.setDefaultTemplate(this.spinnerTemplate);

        this.loadingSubscription.add(
            this.loadingService.loadingTemplate$.subscribe((template) => {
                this.loadingTemplate = template;
                this.cdr.detectChanges();
            })
        );
    }

    ngOnDestroy() {
        this.loadingSubscription.unsubscribe();
    }
}
